export const comparators =
    { 'text' : [
        {
            "name": "text_startswith",
            "value": "Commence par"
        },
        {
            "name": "text_endwith",
            "value": "Fini par"
        },
        {
            "name": "text_contains",
            "value": "Contient"
        },
        {
            "name": "text_notcontains",
            "value": "Ne contient pas"
        },
        {
            "name": "text_is",
            "value": "Est"
        },
        {
            "name": "text_isnot",
            "value": "N'est pas"
        },
        {
            "name": "text_isnull",
            "value": "Est vide"
        },
        {
            "name": "text_isnotnull",
            "value": "N'est pas vide"
        }
    ],
    "number": [
        {
            "name": "number_equals",
            "value": "="
        },
        {
            "name": "number_greaterequals",
            "value": ">="
        },
        {
            "name": "number_lowerequals",
            "value": "<="
        },
        {
            "name": "number_greater",
            "value": ">"
        },
        {
            "name": "number_lower",
            "value": "<"
        },
        {
            "name": "number_different",
            "value": "!="
        },
        {
            "name": "number_isnull",
            "value": "Est vide"
        },
        {
            "name": "number_isnotnull",
            "value": "N'est pas vide"
        }
    ],
    "isnot": [
        {
            "name": "text_is",
            "value": "Est"
        },
        {
            "name": "text_isnot",
            "value": "N'est pas"
        }
    ],
    "bool": [
        {
            "name": "state",
            "value": "Etat"
        }
    ],
    "date": [
        {
            "name": "date_equals",
            "value": "Est le"
        },
        {
            "name": "date_greater",
            "value": "Est postérieur au"
        },
        {
            "name": "date_lower",
            "value": "Est antérieur au"
        },
        {
            "name": "date_different",
            "value": "N'est pas le"
        },
        {
            "name": "date_isnull",
            "value": "Est vide"
        },
        {
            "name": "date_isnotnull",
            "value": "N'est pas vide"
        }
    ]

};